import { render, staticRenderFns } from "./SelectBundle.vue?vue&type=template&id=2beb734f&"
import script from "./SelectBundle.vue?vue&type=script&lang=js&"
export * from "./SelectBundle.vue?vue&type=script&lang=js&"
import style0 from "./SelectBundle.vue?vue&type=style&index=0&id=2beb734f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports